import styled from "styled-components";
import icons from '../../assets/sprite.svg';

import BattleLog from "../battleLog/BattleLog";
import Button from "../button/Button";

const StyledFooter = styled.div`
    display: flex;
    justify-content: space-around;
    width: 850px;
    margin: 30px auto 0;
    padding: 15px 0;
    text-align: center;
    font-size: 16px;
    border-radius: 40px;
    background: linear-gradient(145deg, #cacaca, #f0f0f0);
    box-shadow:  10px 10px 30px #bebebe, -10px -10px 30px #ffffff;
`;

const Flex = styled.div`
    display: flex;
    flex-direction: ${props => props.column ? 'column' : 'row'};
    justify-content: ${props => props.spaceBeetween ? 'space-around' : 'center'};
    align-items: center;
    margin: 0 20px;
    ${props => props.wholeWidth ? 'width: 100%;' : ''}
`;

const HelpItem = styled.div`
    width: 180px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    span {
        text-transform: uppercase;
    }
`;

const Icon = styled.svg`
    display: block;
    margin: auto;
    width: ${props => props.name ? '20px' : '40px'};
    height: ${props => props.name ? '20px' : '40px'};
    margin: ${props => props.name ? '10px' : '3px'};
    fill: ${props => props.name === 'hit' ? '#8B0000' : 'darkslategray'};
    ${props => props.needToScale ? 'transform: scaleX(-1);' : ''}
`;

const SeparateLine = styled.hr`
    width: 90%;
    border-top: 1px solid darkslategray;
`;

const Footer = ({setModal}) => {

    const renderHelpItems = iconsArr => {
        return iconsArr.map(item => {
            return (
                <HelpItem key={item}>
                    <Icon name={item}>
                        <use href={`${icons}#${item}`}/>
                    </Icon>
                    <span>
                        {item === 'hit' ? item : item + 'ed'}
                    </span>
                    <Icon needToScale={item === 'mark' ? false : true}>
                        <use href={`${icons}#click`}/>
                    </Icon>
                </HelpItem>
            )
        });
    }

    const helpItems = renderHelpItems(['hit', 'miss', 'mark']);
    const contacts = Object.entries({
        developer: 'Yaroslav Pidhornyi',
        phone: '097-541-29-26',
        email: 'devinctus.seo@gmail.com'
    }).map(item => {
        return (
            <Flex column key={item[0]}>
                <Icon >
                    <use href={`${icons}#${item[0]}`}/>
                </Icon>
                {item[1]}
            </Flex>
        );
    });

    return (
        <StyledFooter>
            <Flex column>
                <Flex>
                    <Flex column>
                        {helpItems}
                    </Flex>
                    <Flex column>
                        <BattleLog/>
                        <Flex spaceBeetween wholeWidth>
                            {contacts}
                        </Flex>
                    </Flex>
                </Flex>
                <SeparateLine/>
                <Button setModal={setModal}>
                    Start a new game
                </Button>
            </Flex>
        </StyledFooter>
    );
}

export default Footer;